module.exports = __webpack_public_path__ + "img/paul.fcc10b77.jpg";